/**
 * Configuración de useQueryParams para el pivot logístico.
 * Con `prefix` (p. ej. `lp`) las claves en la URL son `lp_start_date`, etc., para embeberse en Logística sin chocar con `start_date` del informe principal.
 */
export function buildPivotQueryParamConfig(
  prefix: string | undefined,
  defaults: { start: string; end: string }
) {
  const key = (name: string) => (prefix ? `${prefix}_${name}` : name);

  return {
    start_date: { type: 'string' as const, default: defaults.start, key: key('start_date') },
    end_date: { type: 'string' as const, default: defaults.end, key: key('end_date') },
    dims: { type: 'string' as const, default: 'year,month', key: key('dims') },
    pivot_view: { type: 'string' as const, default: 'hierarchy', key: key('pivot_view') },
    team_id: { type: 'number' as const, default: null as number | null, key: key('team_id') },
    payment_method_id: { type: 'number' as const, default: null as number | null, key: key('payment_method_id') },
    shop_id: { type: 'number' as const, default: null as number | null, key: key('shop_id') },
    courier_id: { type: 'number' as const, default: null as number | null, key: key('courier_id') },
    country_id: { type: 'number' as const, default: null as number | null, key: key('country_id') },
    courier_service_id: { type: 'number' as const, default: null as number | null, key: key('courier_service_id') },
  };
}
